// extracted by mini-css-extract-plugin
export default {"description":"_1jmdkusSU1UxC3NfqaJ4oX"};